module.exports = __webpack_public_path__ + "img/airport_thumbnail.baf85ca3.jpg";